import {isNotNil} from 'ramda';

/**
 * A Business Case sells one vehicle, and a configuration that produced one keeps holding that
 * slot: `CommitAdmissionPolicy` rejects a second commit while any sibling configuration carries a
 * vehicleId, and neither cancelling the order nor removing the vehicle from the Business Case
 * releases it. Every place that offers a new-vehicle route asks this first, so the UI never
 * invites a commit the backend refuses with `businessCaseAlreadySelected`.
 */
export const holdsBusinessCaseSlot = (
  configurations: {vehicleId: string | null}[] | undefined
): boolean => configurations?.some((configuration) => isNotNil(configuration.vehicleId)) === true;
